import React from 'react';
import { doRequest } from '../../../helper';
import TwitterPost from './TwitterPost';
import PageTitle from '../../PageTitle'
var Twitter = require( 'twitter' );

export default class TwitterFeed extends React.Component {
    constructor( props ) {
        super( props );
        this.state = {
            tweets: []
        }
    }
    componentDidMount() {
        var ref = this;
        var payload = {
            'action': 'update-twitter-feed',
            'module': 'FitIndia',
            'model': 'feed',
            'data': {}
        };
        doRequest( 'cms-operations', payload, true );


        var payload2 = {
            'action': 'list-twitter-feed',
            'module': 'FitIndia',
            'model': 'feed',
            'data': {}
        };
        var request = doRequest( 'cms-operations', payload2, true );

        request.addEventListener( "load", function() {

            var response = this.responseText;
            try {
                response = JSON.parse( response );
                if ( response._resultflag && response._resultflag == 1 ) {
                    ref.setState( { "tweets": response.body } );
                }
            } catch ( ex ) {
                alert( 'Post can not be saved, please try again !' )
            }

        } );



    }
    render() {
        return ( <div><PageTitle title="Fit India Campaign" bread="Fit India Campaign / Social Link - Twitter, Instagram" />
            <div className="wrapper wrapper-content">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-title">
                                <h5>Add Social Post <small> Click to add</small></h5>
                                <div className="ibox-tools">
                                    <a className="collapse-link">
                                        <i className="fa fa-chevron-up"></i>
                                    </a>

                                </div>
                            </div>
                            <div className="ibox-content">
                                <div className="row">
                                    <div className="col-sm-6 b-r" style={{"maxHeight":"500px", "overflowY":"scroll"}}>

                                        {this.state.tweets.map(( tweet ) => {
                                            return ( <TwitterPost tweetId={tweet.tweet_id} /> )

                                        } )}
                                    </div>

                                    <div className="col-sm-6" style={{"maxHeight":"500px", "overflowY":"scroll"}}>
                                      
                                    </div>



                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div > )
    }
}


// WEBPACK FOOTER //
// ./src/Components/FitIndia/Feeds/Twitter.jsx